var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCarDash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 106 60"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#333"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.317,
  d: "M38.431 48.521c4.408-3.759 7.205-9.353 7.205-15.6 0-11.317-9.175-20.491-20.492-20.491S4.652 21.604 4.652 32.92a20.44 20.44 0 0 0 6.642 15.102"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.317,
  d: "M25.515 36.498a3.745 3.745 0 1 0 0-7.49 3.745 3.745 0 0 0 0 7.49Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.317,
  d: "M29.175 49.326c.469-.129.469-.116.469-.129 6.387-1.67 11.174-6.862 12.24-13.47-1.484.402-10.034 2.365-12.71 13.599Zm-7.544.16c-1.559-6.543-4.972-10.328-7.88-12.227-2.085-1.361-3.863-1.65-5.157-1.65 1.06 6.89 6.294 12.402 13.037 13.877Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  strokeWidth: 0.658,
  d: "M5.188 20.586h3.21m34.236.668h6.687"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.317,
  d: "M53.003 9.875a3.29 3.29 0 0 0-3.292 3.292v18.761a3.29 3.29 0 0 0 3.292 3.292h38.64a3.29 3.29 0 0 0 3.292-3.292V13.167a3.29 3.29 0 0 0-3.292-3.292z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.658,
  d: "M94.524 20.984s3.572 2.533 4.127 5.68c.526 2.99 1.682 11.907 1.757 12.509q.003.021-49.64 0c-1.448 0-2.634-.536-3.316-1.606q-1.023-1.604-2.143-1.604"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  strokeWidth: 0.658,
  d: "M51.438 42.922h41.775m-41.775 3.744h41.775"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.317,
  d: "M8.93 28.79c11.652-5.295 22.082-4.847 32.674.354a14 14 0 0 0-.352-1.404c-2.217-6.718-8.545-11.568-16.006-11.568-7.611 0-14.043 5.046-16.135 11.976l-.181.643Z",
  clipRule: "evenodd"
}))));
export default SvgIconCarDash;